
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/range/[range]",
      function () {
        return require("private-next-pages/range/[range]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/range/[range]"])
      });
    }
  